import React, { useState } from 'react';
import { IFingerprintListProps } from '../../store/eligibility/eligibility-interfaces';

interface Props extends IFingerprintListProps {
	checkedItemsList: IFingerprintListProps[];
	setCheckedItemsList: (item: IFingerprintListProps[]) => void;
}

export const BlockListItem = (props: Props): React.ReactElement => {
	const { checkedItemsList, setCheckedItemsList, ...item } = props;
	const [checkedItems, setCheckedItems] = useState<boolean>(false);

	const handleChange = (value: boolean): void => {
		setCheckedItems(value);
		let newCheckedItemsList = [...checkedItemsList];
		if (value) {
			newCheckedItemsList.push({ ...item, blocked: value });
		} else {
			newCheckedItemsList = newCheckedItemsList?.filter(el => el.type !== item.type);
		}
		setCheckedItemsList(newCheckedItemsList);
	};

	return (
		<div className="d-flex align-items-center mt-5">
			<div className='form-check form-check-sm form-check-custom form-check-solid'>
				<input
					className='form-check-input'
					type='checkbox'
					checked={checkedItems}
					onChange={(e): void => handleChange(e.target.checked)}
				/>
			</div>
			<span className="fs-6 mx-2 fw-bolder">{item.friendlyName}</span>
		</div>
	);
};
